import { gql } from '@apollo/client';
export const DELETE_ADDRESS_DATA = gql`
  mutation DELETE_ADDRESS_DATA($input: getAddressInput!) {
    deleteAddressDataAdmin(input: $input) {
      message
    }
  }
`;